import { render, staticRenderFns } from "./SolicitacaoPagamento.vue?vue&type=template&id=1354e40d&"
import script from "./SolicitacaoPagamento.vue?vue&type=script&lang=js&"
export * from "./SolicitacaoPagamento.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports